import { connect } from 'react-redux';

import * as Account from 'app/entities/Account';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import LoadingBlock from 'app/common/components/LoadingBlock';
import hocify from 'app/common/components/hocify';

import AuthAccount from './AuthAccount';

const mapStateToProps = (state, _props) => {
  const isLoading = Account.selectors.all.isLoadImpending(state);
  const currentAccountId = Account.selectors.all.currentAccountId(state);

  return {
    isLoading: isLoading || !currentAccountId,
    LoadingComponent: LoadingBlock,
  };
};

const mapDispatchToProps = dispatch => ({
  onLoad: () => {
    dispatch(Account.actions.loadCollection());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hocify(LoadingBlockOrComponent)(AuthAccount));
